import { Stage } from "views/settings-crm/types/stage";
import { StageOption } from "shared/app/LeadsTableView/slices/LeadsTable/components/types";

export const toStageOptions = (stages: Stage[]): StageOption[] =>
  stages.map((stage) => ({
    label: String(stage.name),
    value: Number(stage.id),
    color: stage.color
  }));
